import type { Profile } from "./types";

/** Defaults shared by local reads and the first profile write. */
export function defaultProfile(id: string, now: string): Profile {
  return {
    id, currency: "SGD",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Singapore",
    cycleStartDay: 1, rolloverMode: "none", onboardedAt: null, defaultCategoryId: null,
    createdAt: now, updatedAt: now,
  };
}
